"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Poseidon = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const BuildColony_1 = require("../../deferredActions/BuildColony");
const CardRenderer_1 = require("../render/CardRenderer");
class Poseidon extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.POSEIDON,
            startingMegaCredits: 45,
            cardType: CardType_1.CardType.CORPORATION,
            initialActionText: 'Place a colony',
            metadata: {
                cardNumber: 'R02',
                description: 'You start with 45 M€. As your first action, place a colony.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br.br;
                    b.megacredits(45).nbsp().colonies(1);
                    b.corpBox('effect', (ce) => {
                        ce.effect('When any colony is placed, including this, raise your M€ production 1 step.', (eb) => {
                            eb.colonies(1).any.startEffect.production((pb) => pb.megacredits(1));
                        });
                    });
                }),
            },
        });
    }
    initialAction(player) {
        if (player.game.gameOptions.coloniesExtension) {
            player.game.defer(new BuildColony_1.BuildColony(player, false, 'Poseidon first action - Select where to build colony'));
            return undefined;
        }
        else {
            console.warn('Colonies extension isn\'t selected.');
            return undefined;
        }
    }
    play() {
        return undefined;
    }
}
exports.Poseidon = Poseidon;
//# sourceMappingURL=Poseidon.js.map